import { COLORS, Col, FlexView, Row } from '@cuemath/comps';
import React, { useCallback, useState } from 'react';
import LAYOUT from 'constants/layout';
import { Button, Separator, Text } from '@cuemath/web-comps';
import { Input } from 'semantic-ui-react';
import styled from 'styled-components';
import { closeModal } from 'actions/modal';
import { useDispatch } from 'react-redux';
import {
  useAddPauseUnitsForTeacherPost,
  useAddPauseUnitsForStudentPost,
} from 'actions/pause-units';

import PropTypes from 'prop-types';

const { GAP, GUTTER } = LAYOUT;

const LabelCol = styled(Col)`
  width: 150px;
  padding-right: ${GUTTER}px;
`;

const PauseUnitModal = ({ teacherId, studentId, studentCourseId, endTime }) => {
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [numberOfUnits, setNumberOfUnits] = useState('');
  console.log({ teacherId, studentId, studentCourseId, endTime });
  const onAddedPauseUnitsComplete = errorMsg => {
    if (errorMsg) {
      setError(errorMsg || 'something went wrong');
    } else {
      dispatch(closeModal());
    }
  };
  const { post: addPauseUnits, isProcessing } = useAddPauseUnitsForTeacherPost({
    onComplete: onAddedPauseUnitsComplete,
  });
  const {
    post: addStudentPauseUnits,
    isProcessing: isStudentProcessing,
  } = useAddPauseUnitsForStudentPost({
    onComplete: onAddedPauseUnitsComplete,
  });

  const handleChange = useCallback((e, { value }) => {
    setNumberOfUnits(value);
  }, []);

  const handleSubmit = useCallback(() => {
    setError('');

    const units = Number(numberOfUnits);
    if (!numberOfUnits || Number.isNaN(units) || units <= 0) {
      setError('Please enter a valid number of units');
      return;
    }

    const payload = {
      total_units: units,
      student_course_id: studentCourseId,
      end_ts: endTime,
    };
    if (studentId && studentCourseId) {
      addStudentPauseUnits(payload, { studentId });
    } else {
      addPauseUnits(payload, { teacherId });
    }
  }, [numberOfUnits, teacherId, studentId, studentCourseId]);

  const enableSubmit =
    (!isProcessing || !isStudentProcessing) &&
    numberOfUnits !== '' &&
    Number(numberOfUnits) > 0;

  return (
    <FlexView gutter={GUTTER} gap={GAP}>
      <Text variant="h6">Add Pause Units</Text>
      <Separator height={24} />

      <Row alignItems="center">
        <LabelCol gutter={0}>
          <Text variant="body1Regular">No. of units</Text>
        </LabelCol>
        <Col auto gutter={0}>
          <Input
            name="total_units"
            type="number"
            placeholder="Enter no. of units"
            value={numberOfUnits}
            onChange={handleChange}
          />
        </Col>
      </Row>
      <Separator height={GUTTER * 6} />
      <FlexView alignItems="center">
        <Button
          isBusy={isProcessing || isStudentProcessing}
          label="Add Units"
          size="small"
          onClick={handleSubmit}
          isDisabled={!enableSubmit}
        />
      </FlexView>
      {error && (
        <FlexView alignItems="center">
          <Separator height={8} />
          <Text variant="body1Regular" color={COLORS.RED}>
            {error}
          </Text>
        </FlexView>
      )}
    </FlexView>
  );
};
PauseUnitModal.propTypes = {
  teacherId: PropTypes.string,
  studentId: PropTypes.string,
  studentCourseId: PropTypes.string,
  endTime: PropTypes.number,
};
export default PauseUnitModal;
